var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('Banner',{attrs:{"success":_vm.success},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}}),_c('back-to-home'),(_vm.memberId)?_c('diff-form',{attrs:{"member-id":_vm.memberId},on:{"submit":_vm.onSubmit}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }